import React from "react";
import ProgramTemplate from "@/components/ProgramTemplate";
import { PROGRAM_FRM_78 } from "@/lib/programs/marrakechFez78";

export default function MarrakechFez78Page() {
  return <ProgramTemplate program={PROGRAM_FRM_78} variant="frm" showJourneyChronology />;
}
